"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let DiscountCouponModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.guid = "";
    this.name = "";
    this.status = 0;
    this.style = "";
    this.type = "";
    this.use_limit_desc = "";
    this.coupon_data = new DiscountCouponFixedModel();
    this.goods_specs = [];
    this.regions = [];
    this.scenes = [];
    this.valid_date = new ValidDateModel();
  }
};
DiscountCouponModel.model = "discount_coupon";
DiscountCouponModel = __decorateClass([
  Annotation.ModelMeta
], DiscountCouponModel);
export let DiscountCouponFixedModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.fixed_money = 0;
    this.rate = 0;
    this.cut = 0;
    this.full = 0;
    this.cash = 0;
    this.type = "";
  }
};
DiscountCouponFixedModel.model = "discount_coupon.fixed";
DiscountCouponFixedModel = __decorateClass([
  Annotation.ModelMeta
], DiscountCouponFixedModel);
export let CouponGoodSpecsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.guid = "";
    this.name = "";
  }
};
CouponGoodSpecsModel.model = "good_spec_coupon_model";
CouponGoodSpecsModel = __decorateClass([
  Annotation.ModelMeta
], CouponGoodSpecsModel);
export let CouponRegionsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.guid = "";
    this.name = "";
  }
};
CouponRegionsModel.model = "region_coupon_model";
CouponRegionsModel = __decorateClass([
  Annotation.ModelMeta
], CouponRegionsModel);
export let ValidDateModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.end = 0;
    this.start = 0;
  }
};
ValidDateModel.model = "valid_coupon_model";
ValidDateModel = __decorateClass([
  Annotation.ModelMeta
], ValidDateModel);
export let ScenesModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.code = "";
    this.name = "";
  }
};
ScenesModel.model = "scene_coupon_model";
ScenesModel = __decorateClass([
  Annotation.ModelMeta
], ScenesModel);
